import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  grid: {
    paddingTop: theme.spacing(2)
  },
  sentOrder: {
    marginTop: theme.spacing(4),
    textAlign: 'right'
  }
}))

export {
  useStyles
}